module.exports = require('./lib/autoBind');



//////////////////
// WEBPACK FOOTER
// ./~/react-autobind/index.js
// module id = 62
// module chunks = 0